import React, { useEffect, useRef, useState } from "react";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { Form, Button, Input, Modal, message } from "antd";
import { Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LoginDialog = ({ open, onClose }) => {
  const navigate = useNavigate();
  const emailInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("email", values.email);
    formData.append("password", values.password);
    try {
      const response = await fetch(
        "https://subd.checkkonproject.com/api/login",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        message.success("เข้าสู่ระบบสำเร็จ");
        const data = await response.json();
        localStorage.setItem("access_token", data.message);
        navigate(`/`);
        window.location.reload();
      } else {
        message.error("อีเมลหรือรหัสผ่านผิดพลาด!");
        console.error("Login failed");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("เกิดข้อผิดพลาดในการเชื่อมต่อ");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (emailInputRef.current) emailInputRef.current.focus();
      }, 200);
    }
  }, [open]);

  const labelStyle = {
    fontSize: "16px",
    fontWeight: 600,
    color: "#334155",
  };

  const inputStyle = {
    borderRadius: "12px",
    height: "48px",
    padding: "10px 16px",
    backgroundColor: "#ffffff",
    color: "#1e293b",
    fontSize: "16px",
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={460}
      destroyOnClose
      centered
    >
      <Box sx={{ textAlign: "center", pt: 1, pb: 0.5 }}>
        <div className="container-title" style={{ marginBottom: 4 }}>
          เข้าสู่ระบบ
        </div>
        <Typography variant="body2" sx={{ color: "#64748b", mb: 1 }}>
          เข้าสู่ระบบเครือข่ายเฝ้าระวังข้อมูลเท็จภาคใต้
        </Typography>
      </Box>
      <Paper
        elevation={0}
        className="form-container"
        style={{ padding: "12px 16px 8px" }}
      >
        <Form
          layout="vertical"
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{
            maxWidth: "100%",
          }}
          size="large"
          autoComplete="off"
        >
          <Form.Item
            label={<span style={labelStyle}>อีเมล</span>}
            name="email"
            rules={[
              {
                required: true,
                message: "กรุณาเพิ่มอีเมล!",
              },
            ]}
          >
            <Input
              ref={emailInputRef}
              style={inputStyle}
              size="large"
              prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
              placeholder="ระบุอีเมลของคุณ"
              autoFocus
            />
          </Form.Item>
          <Form.Item
            label={<span style={labelStyle}>รหัสผ่าน</span>}
            name="password"
            rules={[
              {
                required: true,
                message: "กรุณาเพิ่มรหัสผ่าน!",
              },
            ]}
          >
            <Input.Password
              style={inputStyle}
              size="large"
              prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
              placeholder="ระบุรหัสผ่าน"
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 8, marginTop: 20 }}>
            <Button
              shape="round"
              type="primary"
              htmlType="submit"
              loading={loading}
              className="form-button"
            >
              เข้าสู่ระบบ
            </Button>
          </Form.Item>
        </Form>
      </Paper>
    </Modal>
  );
};

export default LoginDialog;
